import React from "react";
import Modal from "react-responsive-modal";
import LoadMask from "../../../../../../../../Utils/LoadMask/LoadMask";
import { formatDisplayNumber } from "../../../../../../../../../../utility/utils";
import { PESO_KG_PACA_PRODUCCION } from "../../../../../../../../../../utility/constants";
import { SobrantesTable } from "./SobrantesTable";
import { useSobranteReclasificacion } from "../../hooks/useSobranteReclasificacion";

export const ModalSobrante = (props) => {
    const {
        opened,
        onClose,
        sobrantesReclasificacion,
        setSobrantesReclasificacion,
        productoId,
        refreshKey,
        sobrantePendiente,
    } = props;

    const sobrante = useSobranteReclasificacion({
        onClose,
        sobrantesReclasificacion,
        setSobrantesReclasificacion,
        productoId,
        refreshKey,
        sobrantePendiente,
    });

    const { totalKg, pacas, esMultiploDePaca } = sobrante.totales;

    // se trunca (no se redondea) para no aparentar una paca entera cuando
    // el saldo es una fracción (ej. 34.99 kg = 0.99 pacas, no 1.00)
    const pacasTruncadas = Math.floor(pacas * 100) / 100;

    const colorTotal =
        totalKg > 0
            ? esMultiploDePaca
                ? "text-success"
                : "text-danger"
            : "text-muted";

    return (
        <Modal
            open={opened}
            onClose={sobrante.handleClose}
            closeOnOverlayClick={false}
            focusTrapped={false}
        >
            <LoadMask loading={sobrante.cargando} blur>
                <h4 className="text-center mb-4">Agregar sobrante</h4>

                <SobrantesTable
                    existencias={sobrante.draftExistencias}
                    handleChange={sobrante.handleChange}
                />

                <div className="text-center mt-3">
                    <span className={colorTotal} style={{ fontWeight: 600 }}>
                        Total: {formatDisplayNumber(totalKg, 2)} kg ={" "}
                        {formatDisplayNumber(pacasTruncadas, 2)} pacas
                    </span>

                    {totalKg > 0 && !esMultiploDePaca && (
                        <small className="d-block text-danger">
                            Los kg deben completar pacas enteras de{" "}
                            {PESO_KG_PACA_PRODUCCION} kg
                        </small>
                    )}
                </div>

                <div className="d-flex flex-wrap justify-content-center mt-4 mb-2 gap-1rem">
                    <button
                        className="btn btn-outline-dark"
                        onClick={sobrante.handleClose}
                        disabled={sobrante.cargando}
                    >
                        Regresar
                    </button>

                    <button
                        className="btn btn-primary"
                        onClick={sobrante.handleSave}
                        disabled={
                            sobrante.cargando ||
                            (totalKg > 0 && !esMultiploDePaca)
                        }
                    >
                        Guardar
                    </button>
                </div>
            </LoadMask>
        </Modal>
    );
};
